module.exports = __webpack_public_path__ + "img/01 02_water.73820c88.png";